import React from 'react'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Card from '../components/Card';


const MovieSlide = ({movies}) => {
const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 5
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 4
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1
    }
    };


  return (
      <div class = "relative z-0">
        <Carousel responsive={responsive}>
            {movies?.results.map((item) => (
                <Card item = {item} />
            ))}
        </Carousel>
      </div>
    
  )
}

export default MovieSlide